import { render, staticRenderFns } from "./IncomeChart.vue?vue&type=template&id=6bd60b6c&scoped=true&"
import script from "./IncomeChart.vue?vue&type=script&lang=js&"
export * from "./IncomeChart.vue?vue&type=script&lang=js&"
import style0 from "./IncomeChart.vue?vue&type=style&index=0&id=6bd60b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd60b6c",
  null
  
)

export default component.exports